import { motion, useInView } from "framer-motion"
import { useState, useRef } from "react"
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Container,
    Grid,
    Typography,
    IconButton,
    Button,
    Link,
} from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import items from "./Items";

export default function Projects() {

    const [selectedItem, setSelectedItem] = useState(null);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <Container
            component={motion.div}
            maxWidth='xl'
            sx={{ my: { xs: "5vh", sm: "10vh", xl: "20vh" }, mx: { xs: 0, sm: 2 } }}
            id="projects">
            <Typography
                sx={{ my: 5, pb: { xs: 5, xl: 10 } }}
                component={motion.h2}
                initial={{ opacity: 0 }}
                transition={{ delay: 0.5, duration: 1 }}
                animate={isInView ? { opacity: 1 } : "none"}
                variant="h2"
                align='center'
                color="primary"
            >
                Projects
            </Typography>
            <Grid container spacing={"5%"} ref={ref}>
                {items.map(item => {
                    return (
                        <Grid item
                            xs={12}
                            sm={6}
                            sx={{
                                display: "flex", justifyContent: "center",
                            }}
                            component={motion.div}
                            initial={(item.id % 2 === 0) ? { x: -2000, opacity: 0 } : { x: 2000, opacity: 0 }}
                            transition={{ type: "spring", delay: (item.id / 3) }}
                            animate={isInView ? { x: 0, opacity: 1 } : "none"}
                            key={item.id}>
                            <motion.img
                                layout
                                layoutId={item.id}
                                onClick={() => { setSelectedItem(item); }}
                                style={{
                                    width: "100%",
                                    border: "1px solid grey"
                                }}
                                transition={{ type: 'spring' }}
                                exit={{ target: "origin" }}
                                src={item.img} />
                        </Grid>
                    )
                })}
            </Grid>
            {selectedItem &&
                <Dialog
                    open={selectedItem}
                    onClose={() => setSelectedItem(null)}
                >
                    <DialogActions>
                        <IconButton onClick={() => setSelectedItem(null)}>
                            <CloseIcon color="secondary" />
                        </IconButton>
                    </DialogActions>
                    <Link
                        href={selectedItem.website || selectedItem.github}
                        rel="noopener noreferrer"
                        target="_blank">
                        <motion.img
                            layout
                            layoutId={selectedItem.id}
                            exit={{ target: "origin" }}
                            transition={{ type: "spring" }}
                            style={{ width: "100%" }}
                            src={selectedItem.img}
                        />
                    </Link>
                    <DialogContent>
                        <DialogContentText>
                            <Typography variant="h5" color="secondary">{selectedItem.title}</Typography>
                            <Typography variant="body2" >{selectedItem.description}</Typography>
                        </DialogContentText>
                        <DialogActions sx={{ mt: 2 }}>
                            <Button
                                variant='contained'
                                color='primary'
                                size='large'
                            ><Link
                                href={selectedItem.github}
                                rel="noopener noreferrer"
                                target="_blank"
                                sx={{ color: "#121213" }}
                            >GitHub
                                </Link>
                            </Button>
                            {selectedItem.website &&
                                <Button
                                    variant='contained'
                                    size='large'
                                ><Link
                                    href={selectedItem.website}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    sx={{ color: "#121213" }}>
                                        Website
                                    </Link>
                                </Button>
                            }
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            }
        </Container >
    )
}